export default __webpack_public_path__ + "static/media/872.9907ee78.gif";